import './styles/remove-feature-confirmation.css';

import React, {useCallback} from 'react';
import {Button} from '@rescui/button';
import PropTypes from 'prop-types';
import {useTextStyles} from '@rescui/typography';
import cn from 'classnames';

const RemoveFeatureConfirmation = ({
  feature,
  dependents,
  removeFeature,
}) => {
  const textCn = useTextStyles();
  const doRemoveFeature = useCallback(() => {
    const featuresIdsToRemove = [feature.id].concat(
        dependents.map((linkedFeature) => linkedFeature.id),
    );
    removeFeature(featuresIdsToRemove);
  }, [
    feature,
    dependents,
    removeFeature,
  ]);

  return (
    <div className={cn('remove-feature-confirmation', textCn('rs-text-2', { 'hardness': 'hard' }))}>
      <strong>This will also remove:</strong>
      <div className={cn('remove-feature-confirmation__dependents', textCn('rs-text-3'))}>
        {dependents.map((parent) => (
          <div key={parent.id}>{parent.name}</div>
        ))}
      </div>
      <Button size="xs" theme="dark" mode="rock" onClick={doRemoveFeature}>
        {`Remove ${1 + dependents.length} plugins`}
      </Button>
    </div>
  );
};

RemoveFeatureConfirmation.propTypes = {
  feature: PropTypes.object,
  dependents: PropTypes.arrayOf(PropTypes.object),
  unusedDependencies: PropTypes.arrayOf(PropTypes.object),
  removeFeature: PropTypes.func,
};

export default RemoveFeatureConfirmation;
